import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState, createContext } from "react"
import classnames from "classnames"
//redux
import { useDispatch, useSelector } from "react-redux"
import Minusicon from "../../../assets/images/minus_circle.svg"
import Plusicon from "../../../assets/images/plus_circle.svg"
import Reporticon from "../../../assets/images/document_accept.svg"
import Imageicon from "../../../assets/images/image_images.svg"
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import {
  getUserTeamsReport,
  getApprovesTeamsReport,
  getRejectsTeamsReport,
  workReports,
  screenVerified,
  onteamScreenlogs,
  SendReportForSelectedProject,
  GetOnEvaluationHours,
  PostReportQuickSendToClient,
  togglePageLoader
} from "store/actions"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  BrkHrs,
  ClientName,
  IdleHrs,
  PrivateHrs,
  ActiveHrs,
  OnEvaluationHrs,
  ManualHrs,
  StartDateTime,
  EndDateTime,
} from "./VerifyScreenCol"
import FilterLayout from "./FilterLayout"
import VerifyTeamModal from "./VerifyTeamModal"
import { getTeamLookup, getProjectTeams } from "store/createTeam/action"
import RejectModal from "../../../components/Common/RejectModal"
import ApproveModal from "../../../components/Common/ApproveModal"
import Activity_summary from "./activitysummary"
import BootstrapTable from "react-bootstrap-table-next"
import { isEmpty } from "lodash"
import TeamScreen from "./teamscreenlog"
import Fullviewproject from "./Fullviewproject"
import { ExpandRowProject } from "./ExpandRowProject"
import ClientList from "./ClientLists"
//pages
import UserForm from "pages/Admin/ManageClient/usermodalform"
//assets
import projectreport from "../../../assets/images/fullreport.png"
import moment from "moment"
import MobileTable from "components/Common/MobileTable/MobileTable"
import Actions from "./ActionButton/Actions"
import { hoursList, hoursListteam } from "../../../common/data/settings"
import { setIsMobile } from "store/actions"
import VerifyScreenModal from "../VerifyScreens/VerifyScreenModalCopy"
import html2pdf from "html2pdf.js"

const MyContext = createContext()
var getUnVerifiedErrorLists
var getErrorListsUnSubmitted
var getOnEvaluationErrorList
var list
function VerifyScreenTeams() {
  //meta title
  document.title = "Verify Team Hours | TenderSoftware - Flexi TracBoard"

  const dispatch = useDispatch()
  
  // Get default date - yesterday before 11:50am, today after 11:50am
  const getDefaultDate = () => {
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    
    // Check if current time is before 11:50 AM
    if (currentHour < 11 || (currentHour === 11 && currentMinute < 50)) {
      // Use yesterday's date
      const yesterday = new Date(now)
      yesterday.setDate(now.getDate() - 1)
      return yesterday
    } else {
      // Use today's date
      return now
    }
  }
  
  const [startDate, setStartDate] = useState(getDefaultDate())
  const [endDate, setEndDate] = useState(getDefaultDate())
  const [hideDateColumn, sethideDateColumn] = useState(true)
  const [selectedHours, setSelectedHours] = useState([])
  const [selectedHoursteam, setSelectedHoursteam] = useState([])
  const [ismodal, setismodal] = useState(false)
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const toDate = moment(new Date(endDate)).format("YYYY-MM-DD")
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [expandedRow, setExpandedRow] = useState(null)
  const [expandedRowProject, setExpandedRowProject] = useState(null)
  const [rejectModal, setRejectModal] = useState({
    open: false,
    IsAutoClosed: false,
  })
  const [approveModal, setApproveModal] = useState({
    open: false,
    IsAutoClosed: false,
  })
  const [verifyScreen, setverifyScreen] = useState(false)
  const [rowlistData, setRowlistData] = useState({})
  const [handleAccordion, sethandleAccordion] = useState(false)
  const [handleAccordionsummary, sethandleAccordionsummary] = useState(false)
  const [screenResponse, setscreenResponse] = useState()
  const [activeScreenFilter, setActiveScreenFilter] = useState("UNVERIFIED")
  const [summaryModal, setSummaryModal] = useState(false)
  const [summaryModalteam, setSummaryModalteam] = useState(false)
  const [selectToggle, setselecToggle] = useState(false)
  const [summarydatas, setSummarydata] = useState({})
  const [summarydatasteam, setSummarydatateam] = useState({})
  const [activeClientName, setActiveClientName] = useState("ALL")
  const [activeReportStatus, setActiveReportStatus] = useState(undefined)
  const [activeProjectName, setActiveProjectName] = useState("ALL")
  const [activeName, setactiveName] = useState("ALL")
  const [expandRowItem, setExpandRowItem] = useState({})
  // team screen model state maintain
  const [teamscreenModal, setTeamscreenModal] = useState(false)
  const [handleAccordionteamscreen, sethandleAccordionteamscreen] =
    useState(false)

  const [fullviewreport, setFullviewreport] = useState()
  const [FullviewModalteam, setFullviewModalteam] = useState(false)
  const [openUserModal, setOpenUserModal] = useState(false)
  const [createUserScreen, setCreateUserScreen] = useState(false)
  const [selectedRowDetails, setSelectedRowDetails] = useState([])
  const [selectedEvalaution, setSelectedEvaluation] = useState()
  const [selectedReportItem, setSelectedReportItem] = useState({})
  const [teamsReportList, setData] = useState([])
  const [teamsReportListteam, setDatateam] = useState([])
  const [selectedclientId, setSelectedclientId] = useState({})
  const [selectedprojectId, setSelectedprojectId] = useState({})
  const [selecteuserId, setSelecteduserd] = useState({})
  const [rejectModalAll, setRejectModalAll] = useState(false)
  const [approveModalAll, setApproveModalAll] = useState(false)
  const [evaluationall, setEvaluationall] = useState(false)
  const [typeApproveAll, setTypeApproveAll] = useState(null)
  // view by compact view and full view concept
  const [modeCompact, setModeCompact] = useState({
    id: 1,
    label: "Compact View",
    value: "Compact View",
  })
  const [selectedArrayLists, setSelectedArrayLists] = useState(list || [])
  const [emailSendType, setEmailSendType] = useState(null)
  const [downloadLoader, setDownloadLoader] = useState(false)
  const [billableType, setBilliableType] = useState({
    id: 0,
    label: "All",
    value: "All",
  })
  // const [scrollPosition, setScrollPosition] = useState(0);
  
  useEffect(() => {
    dispatch(getTeamLookup())
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 900))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])


  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
   
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  const {
    reports,
    companySetting,
    approaval,
    rejectation,
    screens,
    projectTeam,
    teamscreen,
    updatereport,
    clientsEmail,
    accessgroupname,
    isMobile,
    excludeScreenVerify,
    getallbillingtypes,
    bookmarkedLists,
  } = useSelector(state => ({
    reports: state?.teams?.teamReportSuccessList,
    companySetting: state?.Login?.userDetails?.data,
    approaval: state?.teams?.teamApproveSuccessList?.statusCode,
    rejectation: state?.teams?.teamRejectSuccessList?.statusCode,
    screens: state.timesheet.screenVerifiedSuccessList,
    projectTeam: state?.createteam?.responseProjectTeam,
    teamscreen: state?.timesheet?.teamscreenlogsSuccessList?.data,
    updatereport: state?.trackprofile?.updatereports,
    clientsEmail:
      state?.createteam?.getCategoryUserLists?.categoryuseremailaddress,
    accessgroupname: state?.Login?.usersDetails?.data,
    isMobile: state?.teams?.isMobile,
    excludeScreenVerify: state?.timesheet?.excludescreenSuccessList,
    getallbillingtypes:
      state?.createteam?.createTeamLookupList?.billingTypeLookup,
    bookmarkedLists: state?.teams?.bookmarkedLists
  }))

  // const handleScroll = () => {
  //   setScrollPosition(window.scrollY);
  // };

  // compact view data assign variable
  const compactView = modeCompact?.id

  useEffect(() => {
    setscreenResponse(screens)
  }, [screens])

  useEffect(() => {
    setCreateUserScreen(false)
  }, [openUserModal])

  const onhandleVerified = data => {
    setActiveScreenFilter(data)
  }

  // heading title in react table
  const HeaderFormater = (column, colIndex) => {
    return <strong>{column.text}</strong>
  }


  const toggleChecked = () => {
    setselecToggle(value => !value)
    setModeCompact({
      id: 1,
      label: "Compact View",
      value: "Compact View",
    })
    setActiveReportStatus(undefined)
  }

  const renderWorkStatus = (row, type) => {
    let statusType = ""

    let filterVerifiedLists = (row || []).filter(
      el =>
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]
          ?.screenVerified ||
        !el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist
    )
    let getUnSubmittedLists = (filterVerifiedLists || []).filter(
      el =>
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.workReportId ===
        0
    )
    const getErrorListsUnSubmitted = (getUnSubmittedLists || []).filter(
      item =>
        (row || []).some(ele => ele?.userId === item?.userId) &&
        filterBasedOnHoursteam(item)
    )

    if (type === "user") {
      const workStatus = row?.find(ele => {
        if (
          ele?.workReportSummary?.projectSummaryList[0]
            ?.workReportStatusName === "Submitted"
        ) {
          statusType =
            ele?.workReportSummary?.projectSummaryList[0]?.workReportStatusName
        } else if (
          ele?.workReportSummary?.projectSummaryList[0]
            ?.workReportStatusName === null &&
          ele?.workReportSummary?.projectSummaryList[0]?.workReportDetails ===
          ""
        ) {
          statusType = "Report Not Sbmitted"
        }
      })
    } else {
      if (type === "projects") {
        const samp = row?.find(el => {
          if (
            el?.workReportSummary?.projectSummaryList[0]
              ?.workReportStatusName === "Submitted"
          ) {
            statusType =
              el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName
          } else if (
            el?.workReportSummary?.projectSummaryList[0]
              ?.workReportStatusName === null &&
            el?.workReportSummary?.projectSummaryList[0]?.workReportDetails ===
            ""
          ) {
            statusType = "Report Not Submitted"
          }
        })
      }
    }
    return statusType
  }

  const TeamtimeSheetHeaderColumns = useMemo(
    () => [
      {
        text: "Date",
        dataField: "timeSummaryDate",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        footer: info => (teamsReportListteam.length > 0 ? <span /> : null),
        hidden: hideDateColumn ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "7%", textAlign: "center" }
        },
      },
      {
        text: "Name",
        dataField: "project",
        disableFilters: true,
        style: { width: !compactView == 1 ? "100%" : "" },
        classes: compactView === 1 ? "projectNamesCompact" : "projectNames",
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => <span />,
        filterable: true,
        footer: info => (teamsReportListteam.length > 0 ? <span /> : <></>),
        Cell: cellProps => {
          return <ClientName {...cellProps} />
        },
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "240px", textAlign: "center" }
        },
      },

      {
        text: "In",
        dataField: "startTime",
        style: { textAlign: "center" },
        sort: false,
        filterable: true,
        formatter: (cellContent, row) => (
          <span style={{ opacity: row?.startTime ? "1" : "0" }}>
            {row?.startTime ? row?.startTime : "00:00:00"}
          </span>
        ),
        Cell: cellProps => {
          return <StartDateTime {...cellProps} />
        },
        footer: info => (teamsReportListteam.length > 0 ? <span /> : <></>),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Out",
        dataField: "endTime",
        style: { textAlign: "center" },
        sort: false,
        filterable: true,
        // formatter: (cellContent, row) => <span>{row?.endTime}</span>,
        formatter: (cellContent, row) => (
          <span style={{ opacity: row?.endTime ? "1" : "0" }}>
            {row?.endTime ? row?.endTime : "00:00:00"}
          </span>
        ),
        Cell: cellProps => {
          return <EndDateTime {...cellProps} />
        },
        footer: info => (
          <div className="text-right">
            <span className="">
              {teamsReportListteam.length > 0 ? <span>Total</span> : <></>}{" "}
            </span>
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Hours",
        dataField: "totalHours",
        style: { textAlign: "center", color: "orange" },
        disableFilters: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        sortFunc: (a, b, order) => {
          // Convert time strings to numbers
          const timeToNumber = time => {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
          };

          // Convert time strings to numbers for comparison
          const timeA = timeToNumber(a);
          const timeB = timeToNumber(b);

          // Perform custom comparison based on order
          if (order === 'asc') {
            return timeA - timeB;
          } else {
            return timeB - timeA;
          }
        },
        footer: info => (
          <div className="text-center">
            <span className="text-primary">
              {
                <span className="text-center">
                  {sumofIdleHours("totalHours", teamsReportListteam, true)}
                </span>
              }
            </span>
          </div>
        ),
        filterable: true,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Active",
        dataField: "activeHours",
        style: { textAlign: "center" },
        disableFilters: true,
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span>
              {sumofIdleHours("activeHours", teamsReportListteam, true)}
            </span>
          </div>
        ),
        filterable: true,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Private",
        dataField: "privateHours",
        style: { textAlign: "center" },
        disableFilters: true,
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            {
              <span>
                {sumofIdleHours("privateHours", teamsReportListteam, true)}
              </span>
            }
          </div>
        ),
        filterable: true,
        Cell: cellProps => {
          return <PrivateHrs {...cellProps} />
        },
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Break",
        dataField: "breakHours",
        style: { textAlign: "center" },
        disableFilters: true,
        filterable: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <BrkHrs {...cellProps} />
        },
        footer: info => (
          <div className="text-center">
            {
              <span className="text-center">
                {sumofIdleHours("breakHours", teamsReportListteam, true)}
              </span>
            }
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Idle",
        dataField: "idleHours",
        disableFilters: true,
        style: { textAlign: "center" },
        filterable: true,
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span>
              {sumofIdleHours("idleHours", teamsReportListteam, true)}
            </span>
          </div>
        ),
        Cell: cellProps => {
          return <IdleHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "On Evaluation",
        dataField: "onEvaluationHours",
        disableFilters: true,
        filterable: true,
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span>
              {sumofIdleHours("onEvaluationHours", teamsReportListteam, true)}
            </span>
          </div>
        ),
        Cell: cellProps => {
          return <OnEvaluationHrs {...cellProps} />
        },
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Manual Hours",
        dataField: "manualHours",
        disableFilters: true,
        filterable: true,
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span>
              {sumofIdleHours("manualHours", teamsReportListteam, true)}
            </span>
          </div>
        ),
        Cell: cellProps => {
          return <ManualHrs {...cellProps} />
        },
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Approved",
        dataField: "approvedHours",
        style: { textAlign: "center" },
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (teamsReportListteam.length > 0 ? <span /> : <></>),
        filterable: true,
        formatter: (cellContent, row) => (
          <span style={{ opacity: row?.approvedHours ? "1" : "0" }}>
            {row?.approvedHours ? row?.approvedHours : "00:00:00"}
          </span>
        ),
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Rejected",
        dataField: "rejectedHours",
        style: { textAlign: "center" },
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (teamsReportListteam.length > 0 ? <span /> : <></>),
        filterable: true,
        formatter: (cellContent, row) => (
          <span style={{ opacity: row?.rejectedHours ? "1" : "0" }}>
            {row?.rejectedHours ? row?.rejectedHours : "00:00:00"}
          </span>
        ),
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Status",
        disableFilters: true,
        dataField: "workReportStatusName",
        style: {
          textAlign: "center",
          width: "10%",
          whiteSpace: "pre-line",
        },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => <span />,
        filterable: true,
        formatter: (cellContent, row) =>
          row?.workReportStatusName ? row?.workReportStatusName : "",
        Cell: cellProps => {
          return <ClientName {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Action",
        style: { textAlign: "center", pointerEvents: "auto" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => <span />,
        formatter: (cellContent, row) => (
          <>
            <Actions
              Reporticon={Reporticon}
              Imageicon={Imageicon}
              summaryDatateam={summaryDatateam}
              summaryData={summaryData}
              handleverifyScreenproject={handleverifyScreenproject}
              fullviewteamreport={fullviewteamreport}
              renderWorkStatus={renderWorkStatus}
              projectreport={projectreport}
              selectToggle={selectToggle}
              isMobile={isMobile}
              row={row}
              loadTeamScreenteam={loadTeamScreenteam}
            />
          </>
        ),

        Cell: cellProps => {
          return <></>
        },

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "140px", textAlign: "center", pointerEvents: "auto" }
        },
      },
    ],
    [hideDateColumn, teamsReportListteam, compactView]
  )

  const timeSheetHeaderColumns = useMemo(
    () => [
      {
        text: "Date",
        dataField: "timeSummaryDate",
        style: { textAlign: "center", padding: "15px 5px" },
        sort: true,
        filterable: true,
        footer: info => (teamsReportList.length > 0 ? <span /> : null),
        hidden: hideDateColumn ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        headerStyle: (colum, colIndex) => {
          return { width: "10%", textAlign: "center" }
        },
      },
      {
        text: "Name",
        dataField: "displayName",
        disableFilters: true,
        style: { width: "15%" },
        sort: true,
        footer: info => (teamsReportList.length > 0 ? <span /> : null),
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        filterable: true,
        Cell: cellProps => {
          return <ClientName {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "200px", textAlign: "center" }
        },
      },

      {
        text: "In",
        dataField: "startTime",
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        filterable: true,
        footer: info => (teamsReportList.length > 0 ? <span /> : null),
        formatter: (cellContent, row) => (
          <span>{moment(row?.startTime).format("HH:mm:ss")}</span>
        ),
        Cell: cellProps => {
          return <StartDateTime {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Out",
        dataField: "endTime",
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        filterable: true,
        footer: info => (
          <div className="text-right ">
            <span className="font-weight-bold">
              {teamsReportList.length > 0 ? <span>Total</span> : null}
            </span>
          </div>
        ),
        formatter: (cellContent, row) => (
          <span>{moment(row?.endTime).format("HH:mm:ss")}</span>
        ),
        Cell: cellProps => {
          return <EndDateTime {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Hours",
        dataField: "totalHours",
        style: { textAlign: "center", color: "orange" },
        disableFilters: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        sortFunc: (a, b, order) => {
          // Convert time strings to numbers
          const timeToNumber = time => {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
          };

          // Convert time strings to numbers for comparison
          const timeA = timeToNumber(a);
          const timeB = timeToNumber(b);

          // Perform custom comparison based on order
          if (order === 'asc') {
            return timeA - timeB;
          } else {
            return timeB - timeA;
          }
        },
        footer: info => (
          <div className="text-center">
            <span className="text-primary">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("totalHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        filterable: true,
        // formatter: (cellContent, row) => <span>{row?.totalHours}</span>,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Active",
        dataField: "activeHours",
        style: { textAlign: "center" },
        disableFilters: true,
        hidden: compactView == 1 ? true : false,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("activeHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        filterable: true,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Private",
        dataField: "privateHours",
        style: { textAlign: "center" },
        disableFilters: true,
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("privateHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        filterable: true,
        Cell: cellProps => {
          return <PrivateHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Break",
        dataField: "breakHours",
        style: { textAlign: "center" },
        disableFilters: true,
        filterable: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <BrkHrs {...cellProps} />
        },
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("breakHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },

      {
        text: "Idle",
        dataField: "idleHours",
        disableFilters: true,
        style: { textAlign: "center" },
        filterable: true,
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <IdleHrs {...cellProps} />
        },
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("idleHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "On Evaluation",
        dataField: "onEvaluationHours",
        disableFilters: true,
        filterable: true,
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("onEvaluationHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Manual Hours",
        dataField: "manualHours",
        disableFilters: true,
        filterable: true,
        style: { textAlign: "center" },
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span>
              {sumofIdleHours("manualHours", teamsReportListteam, true)}
            </span>
          </div>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Approved",
        dataField: "approvedHours",
        style: { textAlign: "center" },
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("approvedHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        filterable: true,
        formatter: (cellContent, row) => <span>{row?.approvedHours}</span>,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Rejected",
        dataField: "rejectedHours",
        style: { textAlign: "center" },
        sort: true,
        hidden: compactView == 1 ? true : false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: info => (
          <div className="text-center">
            <span className="text-center">
              {teamsReportList.length > 0 ? (
                <span>
                  {sumofIdleHours("rejectedHours", teamsReportList, true)}
                </span>
              ) : null}
            </span>
          </div>
        ),
        filterable: true,
        formatter: (cellContent, row) => <span>{row?.rejectedHours}</span>,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Action",
        style: { pointerEvents: "auto" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        footer: info => (teamsReportList.length > 0 ? <span /> : null),
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            <Actions
              Reporticon={Reporticon}
              selectToggle={selectToggle}
              Imageicon={Imageicon}
              reportIconClick={summaryData}
              summaryData={summaryData}
              summaryDatateam={summaryDatateam}
              imageIconClick={handleverifyScreenrow}
              handleverifyScreenrow={handleverifyScreenrow}
              renderWorkStatus={renderWorkStatus}
              isMobile={isMobile}
              row={row}
            />
          </>
        ),
        Cell: cellProps => {
          return <></>
        },
        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "140px", textAlign: "center", pointerEvents: "auto" }
        },
      },
    ],
    [hideDateColumn, teamsReportList, compactView]
  )

  useEffect(() => {
    const reportsX = (reports || [])?.map(el => {
      return {
        ...el,
        id: `${el.timeSummaryDate}_${el.userId}`,
        date: el.timeSummaryDate,
        data: el.projectTimeSheet,
        userid: el.userId,
      }
    })

    setData(reportsX)
  }, [reports])

  useEffect(() => {
    // dispatch((togglePageLoader(true)))
    const reportsY = (projectTeam || [])?.map(el => {
      return {
        ...el,
        id: `${el.timeSummaryDate}_${el.projectId}`,
        date: el.timeSummaryDate,
        data: el.timeSheetReports,
        userid: el.projectId,
      }
    })
    setDatateam(reportsY)

    // setTimeout(()=>{
    //   window.scrollTo(0, scrollPosition);
    //   dispatch((togglePageLoader(false)))
    // },2000)
    
  }, [projectTeam])

  const padZero = value => {
    return value > 9 ? value : `0${value}`
  }

  // Adding private, idle, break hours
  const sumofIdleHours = (key, arr, returnValue) => {
    if (arr.length <= 0) return <></>

    const timesarr = []
      ; (arr || []).map((item, index) => {
        timesarr.push(item[key])
      })
    const sum = timesarr?.reduce(
      (acc, time) => acc.add(moment.duration(time)),
      moment.duration()
    )
    if (returnValue)
      return [
        padZero(Math.floor(sum.asHours())),
        padZero(sum.minutes()),
        padZero(sum.seconds()),
      ].join(":")
    return (
      <>
        <strong>
          {[
            padZero(Math.floor(sum.asHours())),
            padZero(sum.minutes()),
            padZero(sum.seconds()),
          ].join(":")}
        </strong>
      </>
    )
  }

  useEffect(() => {
    if (selectToggle == false) {
      loadTeamScreenteam()
    } else {
      loadTeamScreen()
    }
  }, [selectToggle, selectedprojectId, selectedclientId, billableType])

  useEffect(() => {
    if (approaval == 200 || rejectation == 200) {
      selectToggle ? loadTeamScreen() : loadTeamScreenteam();
    }
  }, [approaval, rejectation])

  const loadTeamScreen = () => {
    const userTeams = {
      userid: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      fromDate: fromDate,
      toDate: toDate,
    }
    dispatch(getUserTeamsReport(userTeams))
  }

  const loadTeamScreenteam = () => {
    let userTeams = {
      userid: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      fromDate: fromDate,
      toDate: toDate,
      categoryid:
        selectedclientId?.clientName == undefined ? 0 : selectedclientId?.id,
      subcategoryid:
        selectedprojectId?.projectName == undefined ? 0 : selectedprojectId?.id,
      billingid: billableType?.id == 0 ? 0 : billableType?.id,
      isFavorite: localStorage.getItem("bookmark") ? JSON.parse(localStorage.getItem("bookmark")) : false
    }
    dispatch(getProjectTeams(userTeams))
  }

  const onHandleFilterBtnClicked = () => {
    loadTeamScreen()
  }
  const onHandleFilterBtnClickedteam = () => {
    loadTeamScreenteam()
  }

  const handleProjectFilter = data => {
    setActiveProjectName(data?.projectName || "ALL")
  }
  const handleClientFilter = data => {
    setActiveClientName(data?.clientName || "ALL")
  }

  const handleReportFilter = data => {
    setActiveReportStatus(data)
  }
  // view by compact and full view
  const handleCompactFilter = data => {
    setModeCompact(data)
  }
  // view billable type concept
  const handlebillableFilter = data => {
    setBilliableType(data)
  }
  const handleHoursFilter = hours => {
    setSelectedHours(hours)
  }
  const handleHoursFilterteam = hours => {
    setSelectedHoursteam(hours)
  }

  const handleNameFilter = value => {
    setactiveName(value?.label || "ALL")
  }

  const filterBasedOnHours = rowData => {
    const filtObj = selectedHours?.reduce(
      (a, v) => ({ ...a, [v.dataField]: true }),
      {}
    )
    return (
      (!filtObj.idleHours ||
        (filtObj.idleHours && rowData.idleHours !== "00:00:00")) &&
      (!filtObj.activeHours ||
        (filtObj.activeHours && rowData.activeHours !== "00:00:00")) &&
      ((filtObj.breakHoursteam && rowData.breakHours !== "00:00:00") ||
        !filtObj.breakHoursteam) &&
      (!filtObj.privateHours ||
        (filtObj.privateHours && rowData.privateHours !== "00:00:00")) &&
      (!filtObj.onEvaluationHours ||
        (filtObj.onEvaluationHours && rowData.onEvaluationHours !== "00:00:00"))&&
      (!filtObj.manualHours ||
        (filtObj.manualHours && rowData.manualHours !== "00:00:00")) 
    )
  }

  const filterBasedOnHoursteam = rowData => {
    const filtObj = selectedHoursteam?.reduce(
      (a, v) => ({ ...a, [v.dataField]: true }),
      {}
    )
    return (
      (!filtObj.idleHours ||
        (filtObj.idleHours && rowData.idleHours !== "00:00:00")) &&
      (!filtObj.activeHours ||
        (filtObj.activeHours && rowData.activeHours !== "00:00:00")) &&
      ((filtObj.breakHours && rowData.breakHours !== "00:00:00") ||
        !filtObj.breakHours) &&
      (!filtObj.privateHours ||
        (filtObj.privateHours && rowData.privateHours !== "00:00:00")) &&
      (!filtObj.onEvaluationHours ||
        (filtObj.onEvaluationHours && rowData.onEvaluationHours !== "00:00:00")) &&
      (!filtObj.manualHours ||
        (filtObj.manualHours && rowData.manualHours !== "00:00:00"))
    )
  }

  const handleApprove = (value, IsAutoClosed) => {
    setSelectedEvaluation(value)
    setApproveModal({ open: value, IsAutoClosed })
  }

  const handleReject = (value, IsAutoClosed) => {
    setSelectedEvaluation(value)
    setRejectModal({ open: value, IsAutoClosed })
  }

  const handleApproveAll = () => {
    setApproveModalAll(true)
    setEvaluationall(true)
  }

  const handleRejectAll = () => {
    setRejectModalAll(true)
    setEvaluationall(true)
  }

  const getReportStatus = (lists, activeReportStatus, type) => {
    let filterArr = []
    let getUnVerifiedLists = (lists || []).filter(
      el =>
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist &&
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]
          ?.screenVerified === false
    )
    const getUnVerifiedErrorLists = (getUnVerifiedLists || []).filter(item =>
      (lists || []).some(
        ele =>
          ele?.userId === item?.userId &&
          (type === "users"
            ? filterBasedOnHours(item)
            : filterBasedOnHoursteam(item))
      )
    )

    let filterVerifiedLists = (lists || []).filter(
      el =>
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]
          ?.screenVerified ||
        !el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist
    )
    let getUnSubmittedLists = (filterVerifiedLists || []).filter(
      el =>
        el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.workReportId ===
        0
    )
    const getErrorListsUnSubmitted = (getUnSubmittedLists || []).filter(
      item =>
        (lists || []).some(ele => ele?.userId === item?.userId) &&
        (type === "users"
          ? filterBasedOnHours(item)
          : filterBasedOnHoursteam(item))
    )

    const getReadyorSubmittedList = activeReportStatus?.value ? (lists || [])?.filter(
      el =>
        el.workReportSummary?.projectSummaryList[0]?.workReportStatusName ===
        activeReportStatus?.value &&
        (type === "users" ? filterBasedOnHours(el) : filterBasedOnHoursteam(el))
    ) : (lists || [])?.filter(
      el => (type === "users" ? filterBasedOnHours(el) : filterBasedOnHoursteam(el))
    )

    if (activeReportStatus?.value === "Report Not Submitted") {
      filterArr = getErrorListsUnSubmitted
    } else if (activeReportStatus?.value === "Screen Not Verified") {
      filterArr = getUnVerifiedErrorLists
    } else {
      filterArr = getReadyorSubmittedList
    }
    return filterArr
  }

  useEffect(() => {
    let filtWeek = []
    const reportsX = (reports || []).map(el => {
      return {
        ...el,
        id: `${el.timeSummaryDate}_${el.userId}`,
        date: el.timeSummaryDate,
        data: el.projectTimeSheet,
        iskey: true,
      }
    })
    const filterData = reportsX?.map(el => {
      if (!isEmpty(activeReportStatus)) {
        filtWeek = getReportStatus(
          el.projectTimeSheet,
          activeReportStatus,
          "users"
        )
      } else {
        filtWeek = el.projectTimeSheet?.filter(
          el =>
            (el.userName?.replace(/\s+/g, "") ===
              activeName?.replace(/\s+/g, "") ||
              el?.userName?.includes(activeName) ||
              activeName === "ALL") &&
            filterBasedOnHours(el)
        )
      }
      return {
        ...el,
        projectTimeSheet: filtWeek,
        totalHours: sumofIdleHours("totalHours", filtWeek, true),
        privateHours: sumofIdleHours("privateHours", filtWeek, true),
        breakHours: sumofIdleHours("breakHours", filtWeek, true),
        activeHours: sumofIdleHours("activeHours", filtWeek, true),
        idleHours: sumofIdleHours("idleHours", filtWeek, true),
        onEvaluationHours: sumofIdleHours("onEvaluationHours", filtWeek, true),
        manualHours: sumofIdleHours("manualHours", filtWeek, true),
      }
    })
    setData(filterData)
  }, [
    reports,
    activeClientName,
    activeProjectName,
    activeReportStatus,
    selectedHours,
    activeName,
  ])

  useEffect(() => {
    if (updatereport?.message === "Work Report Updated Successfully" || updatereport?.message === "Work Report Inserted Successfully" || excludeScreenVerify?.message === "Exclude ScreenLog  Successfully") {
      selectToggle ? loadTeamScreen() : loadTeamScreenteam();
      setismodal(false);
    }
  }, [updatereport, excludeScreenVerify])

  useEffect(() => {
    // dispatch((togglePageLoader(true)))
    let filtWeeks = []
    const reportsY = (projectTeam || []).map(el => {
      return {
        ...el,
        id: `${el.timeSummaryDate}_${el.projectId}`,
        date: el.timeSummaryDate,
        data: el.timeSheetReports,
        iskeys: true,
        project: `${el.clientName}_${el.projectName}`,
      }
    })

    const filterDatas = reportsY?.map(el => {
      if (!isEmpty(activeReportStatus)) {
        filtWeeks = getReportStatus(
          el.timeSheetReports,
          activeReportStatus,
          "projects"
        )
      } else {
        filtWeeks = el.timeSheetReports?.filter(
          el =>
            (el.clientName === activeClientName ||
              activeClientName === "ALL") &&
            filterBasedOnHoursteam(el)
        )
      }
      return {
        ...el,
        timeSheetReports: filtWeeks,
        totalHours: sumofIdleHours("totalHours", filtWeeks, true),
        privateHours: sumofIdleHours("privateHours", filtWeeks, true),
        breakHours: sumofIdleHours("breakHours", filtWeeks, true),
        activeHours: sumofIdleHours("activeHours", filtWeeks, true),
        idleHours: sumofIdleHours("idleHours", filtWeeks, true),
        onEvaluationHours: sumofIdleHours("onEvaluationHours", filtWeeks, true),
        manualHours: sumofIdleHours("manualHours", filtWeeks, true),
      }
    })

    setDatateam(filterDatas)

    // setTimeout(()=>{
    //   window.scrollTo(0, scrollPosition);
    //   dispatch((togglePageLoader(false)))
    // },2000)

    // }, [projectTeam, activeClientName, activeReportStatus, selectedHoursteam])
  }, [activeReportStatus, selectedHoursteam, projectTeam])

  const handleScreenResponse = status => {
    if (!isEmpty(status)) {
      if (isEmpty((status || []).filter(el => !el.verified)))
        setActiveScreenFilter("VERIFIED")
      else setActiveScreenFilter("UNVERIFIED")
    } else setActiveScreenFilter("UNVERIFIED")
    setverifyScreen(!verifyScreen)
  }
  const handleverifyScreen = value => {
    const selectedData = value
    const startDate = moment(new Date(selectedData?.startTime)).format(
      "YYYY-MM-DD"
    )
    const endDate = moment(new Date(selectedData?.endTime)).format("YYYY-MM-DD")
    const screenVerifyparams = {
      accountid: selectedData?.accountId,
      includeBase64: "false",
      filterEmptyResponses: "false",
      startDateTime: startDate, //fromDate,
      endDateTime: endDate, //toDate
    }
    setExpandRowItem(screenVerifyparams)
    dispatch(screenVerified(screenVerifyparams, handleScreenResponse))
  }
  const handleverifyScreenrow = value => {
    const selectedData = value
    const startDate = moment(new Date(selectedData.startTime)).format(
      "YYYY-MM-DD"
    )
    const endDate = moment(new Date(selectedData.endTime)).format("YYYY-MM-DD")
    const screenVerifyparams = {
      accountid: !isMobile
        ? selectedData?.projectTimeSheet[0]?.accountId
        : selectedData.accountId,
      includeBase64: "false",
      filterEmptyResponses: "false",
      startDateTime: startDate, //fromDate,
      endDateTime: endDate, //toDate
    }

    setExpandRowItem(screenVerifyparams)
    dispatch(screenVerified(screenVerifyparams))
    setverifyScreen(!verifyScreen)
  }
  // team based project handleSubmit
  const handleverifyScreenproject = value => {
    const selectedData = value
    const screenteamsparams = {
      subcategoryid: selectedData?.projectId,
      date: selectedData?.date,
    }
    dispatch(onteamScreenlogs(screenteamsparams))
    setTeamscreenModal(true)
  }
  const toggleViewModal = value => {
    dispatch(
      GetOnEvaluationHours({
        accountId: value?.accountId,
        date: !isMobile ? value?.date : value?.timeSummaryDate,
      })
    )
    if (!ismodal) {
      const selectedData = selectToggle ? value : value
      if (selectedData !== null) {
        setismodal(true)
        setRowlistData(selectedData)
      } else {
        setismodal(false)
      }
      const startDate = moment(new Date(selectedData?.startTime)).format(
        "YYYY-MM-DD"
      )
      const params = {
        userId: selectedData?.userId,
        date: startDate,
        accountid: selectedData?.accountId,
      }
      if (startDate !== "Invalid date") {
        dispatch(workReports(params))
        // setismodal(!ismodal)
      }
    }
    setismodal(!ismodal)
  }

  const handlecancel = () => {
    setismodal(!ismodal)
  }

  const handleResponse = status => {
    const userTeams = {
      userid: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      fromDate: fromDate,
      toDate: toDate,
      isFavorite: localStorage.getItem("bookmark") ? JSON.parse(localStorage.getItem("bookmark")) : false
    }
    if (status === "SUCCESS") {
      dispatch(getProjectTeams(userTeams))
      setOpenUserModal(false)
    }
  }

  const HandleSubmitClick = selectedLists => {
    const postReq = {
      date: !isMobile
        ? selectedRowDetails[0]?.date
        : selectedRowDetails[0]?.timeSummaryDate,
      subcategoryId: selectedRowDetails[0]?.projectId,
      toemails: selectedLists,
      accountId: (selectedRowDetails || []).map(el => el?.accountId),
    }
    emailSendType == "quickReport" ? dispatch(PostReportQuickSendToClient(postReq, handleResponse)) : dispatch(SendReportForSelectedProject(postReq, handleResponse))
  }

  const expandRow = {
    parentClassName: "table-info bg-opacity-25",
    renderer: row => {
      const lists = (row?.projectTimeSheet || []).map((el, id) => ({
        ...el,
        hideDate: "",
        id: `${row?.timeSummaryDate}_`,
        userid: el?.userId,
        date: row?.timeSummaryDate,
        // reportValue: el.workReportSummary?.projectSummaryList[0]?.tasks?.map(
        //   item => item?.reportValue
        // ),
        reportValue:
          el.workReportSummary?.projectSummaryList[0]?.workReportDetails,
        items: (el.workReportSummary?.projectSummaryList[0]?.tasks || []).map(
          obj => {
            return {
              ...obj,
              startTime: el?.startTime,
              endTime: el?.endTime,
              approvedHours: el?.approvedHours,
              rejectedHours: el?.rejectedHours,
            }
          }
        ),
        accountId: el.accountId,
        keyId: el.workReportSummary?.projectSummaryList[0]?.tasks?.map(
          item => item.workReportId
        ),
      }))
      return (
        <div>
          {lists?.map((subCategory, catIdx) => (
            <React.Fragment
              key={`${subCategory?.accountId}_${subCategory?.clientId}_${subCategory?.projectId}_sub_cat${catIdx}`}
            >
              {subCategory.items?.map((items, idx) => (
                <table
                  className="table mb-0 custom-table-teams-new align-margin-table"
                  key={items.id}
                >
                  <tr role="row" style={{ background: "#FEE4CA" }}>
                    <td
                      style={{
                        width:
                          compactView == 2
                            ? hideDateColumn == false
                              ? "4%"
                              : "3%"
                            : hideDateColumn == false
                              ? "3%"
                              : "4%",
                        padding: "10px",
                      }}
                      className="table-tds"
                    ></td>
                    {!hideDateColumn && (
                      <td
                        className="table-padd"
                        style={{
                          width: `${hideDateColumn == true ? "92px" : "8%"}`,
                          textAlign: "center",
                        }}
                      ></td>
                    )}
                    <td
                      id="disp-name"
                      style={{
                        width: `${compactView == 2
                          ? hideDateColumn == false
                            ? "7%"
                            : "14%"
                          : hideDateColumn == false
                            ? "18.6%"
                            : "17%"
                          }`,
                        minWidth:
                          compactView == 2
                            ? hideDateColumn == false
                              ? "250px"
                              : "215px"
                            : hideDateColumn == false
                              ? "220px"
                              : "221px",
                      }}
                    >
                      {items?.displayName}
                    </td>
                    <td
                      className={
                        !hideDateColumn
                          ? "table-padd tds-width"
                          : "table-padd tds-width-mob"
                      }
                      style={{
                        width: "92px",
                        textAlign: "center",
                      }}
                    >
                      {moment(items?.startTime).format("HH:mm:ss")}
                    </td>
                    <td
                      className={
                        !hideDateColumn
                          ? "table-padd tds-width"
                          : "table-padd tds-width-mob"
                      }
                      style={{
                        width: "92px",
                        textAlign: "center",
                      }}
                    >
                      {moment(items?.endTime).format("HH:mm:ss")}
                    </td>
                    <td
                      className={
                        !hideDateColumn
                          ? "table-padd tds-width"
                          : "table-padd tds-width-mob"
                      }
                      style={{
                        width: "92px",
                        textAlign: "center",
                        color: "orange",
                      }}
                    >
                      {items.totalHours}
                    </td>
                    {compactView == 2 && (
                      <td
                        className="table-padd"
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.activeHours}
                      </td>
                    )}
                    {compactView == 2 && (
                      <td
                        className="table-padd"
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.privateHours}
                      </td>
                    )}
                    <td
                      className="table-padd"
                      style={{
                        width: "92px",
                        textAlign: "center",
                      }}
                    >
                      {items.breakHours}
                    </td>
                    {compactView == 2 && (
                      <td
                        className="table-padd table-pading"
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.idleHours}
                      </td>
                    )}
                    <td
                      className="table-padd table-pading"
                      style={{
                        width: "92px",
                        textAlign: "center",
                      }}
                    >
                      {items.onEvaluationHours}
                    </td>
                    {compactView == 2 && (
                      <td
                        className="table-padd table-pading"
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.idleHours}
                      </td>
                    )}
                    <td
                      className="table-padd table-pading"
                      style={{
                        width: "92px",
                        textAlign: "center",
                      }}
                    >
                      {items.manualHours}
                    </td>
                    {compactView == 2 && (
                      <td
                        className={
                          !hideDateColumn
                            ? "table-padd tds-width"
                            : "table-padd tds-width-mob"
                        }
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.approvedHours}
                      </td>
                    )}
                    {compactView == 2 && (
                      <td
                        className={
                          !hideDateColumn
                            ? "table-padd tds-width"
                            : "table-padd tds-width-mob"
                        }
                        style={{
                          width: "92px",
                          textAlign: "center",
                        }}
                      >
                        {items.rejectedHours}
                      </td>
                    )}
                    <td
                      className="table-padd table-tds last-view-tables"
                      style={{
                        borderTopRightRadius: "10px",
                        width: `${compactView == 2
                          ? hideDateColumn == false
                            ? "8%"
                            : "8%"
                          : hideDateColumn == false
                            ? "12.8%"
                            : "15%"
                          }`,
                      }}
                      colSpan={2}
                    ></td>
                  </tr>
                  <tr style={{ background: "#FEE4CA" }}>
                    <td
                      style={{
                        width: "2%",
                        background: "#FEE4CA",
                        borderBottomLeftRadius: "10px",
                        border: "none !important",
                      }}
                      className="table-tds"
                    ></td>
                    <td
                      colSpan={
                        compactView != 2
                          ? hideDateColumn
                            ? 6
                            : 7
                          : hideDateColumn
                            ? 11
                            : 12
                      }
                      className="p-0 table-tds mobile-table-width"
                    >
                      <div
                        className="input-static-widthteams pre-wrap"
                        style={{
                          background: "#fff",
                          marginBottom: "1.5rem",
                          minHeight: "90px",
                          borderBottomWidth: "2px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: items?.reportDetail,
                        }}
                      />
                    </td>
                    <td
                      className="p-0 table-tds"
                      style={{
                        borderBottomRightRadius: "10px",
                        border: "none",
                      }}
                    >
                      <div className="buttons-team-desktop">
                        <Button
                          color="primary mb-2 customs-button-team"
                          onClick={e => {
                            toggleViewModal(subCategory)
                          }}
                        >
                          Verify Report
                        </Button>
                        <Button
                          color="primary customs-button-team"
                          onClick={e => handleverifyScreen(subCategory)}
                        >
                          Verify Screens
                        </Button>
                      </div>
                    </td>
                  </tr>
                </table>
              ))}
            </React.Fragment>
          ))}
        </div>
      )
    },
    showExpandColumn: true,
    expandColumnPosition: "left",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <span />
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <img src={Minusicon} alt={Minusicon} />
      }
      return <img src={Plusicon} alt={Plusicon} />
    },
    onExpand: (row, isExpand) => {
      if (isExpand) {
        setExpandedRow(row.id)
      } else {
        setExpandedRow(null)
      }
    },
    expanded: [expandedRow],
  }
  const isDateLessThanCurrent = moment(new Date())?.format("YYYY-MM-DD")

  const ExcludeNonReportFunction = () => {
    const excludeErrrorLists = (selectedArrayLists || []).filter(
      el =>
        !(
          el?.workReportSummary?.projectSummaryList[0]?.tasks[0]
            ?.screenVerified === false ||
          el?.workReportSummary?.projectSummaryList[0]?.tasks[0]
            ?.workReportId === 0
        )
    )
    setSelectedArrayLists(excludeErrrorLists)
  }

  const noRowsSelected = isEmpty(selectedArrayLists)
  const expandRowProject = {
    parentClassName: "table-info bg-opacity-25",
    renderer: (row, rowIndex) => {
      const list = (row?.timeSheetReports || []).map(el => ({
        ...el,
        _isExpanding: rowIndex,
        hideDate: "",
        id: `${row.timeSummaryDate}_${row.clientId}_${row.projectId}`,
        userid: el.userId,
        date: row.timeSummaryDate,
        reportValue: el.workReportSummary?.projectSummaryList[0]?.tasks?.map(
          item => item?.reportValue
        ),
        workReportStatusName: row?.workReportStatusName[0],
        items: (el.workReportSummary?.projectSummaryList[0]?.tasks || []).map(
          obj => {
            return {
              ...obj,
              startTime: el?.startTime,
              endTime: el?.endTime,
              approvedHours: el?.approvedHours,
              rejectedHours: el?.rejectedHours,
            }
          }
        ),
        keyId: el.workReportSummary?.projectSummaryList[0]?.tasks?.map(
          item => item.workReportId
        ),
      }))
      return (
        <ExpandRowProject
          list={list}
          hideDateColumn={hideDateColumn}
          selectToggle={selectToggle}
          setSelectedReportItem={setSelectedReportItem}
          toggleViewModal={toggleViewModal}
          handleverifyScreen={handleverifyScreen}
          onClickSubmitButton={onClickSubmitButton}
          onClickQuickSendToClient={onClickQuickSendToClient}
          accessgroupname={accessgroupname}
          isDateLessThanCurrent={isDateLessThanCurrent}
          compactView={compactView}
          ExcludeNonReportFunction={ExcludeNonReportFunction}
          selectedArrayLists={selectedArrayLists}
          setSelectedArrayLists={setSelectedArrayLists}
          noRowsSelected={noRowsSelected}
          isMobile={isMobile}
        />
      )
    },
    showExpandColumn: true,
    expandColumnPosition: "left",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <span />
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <img src={Minusicon} alt={Minusicon} />
      }
      return <img src={Plusicon} alt={Plusicon} />
    },
    onExpand: (row, isExpand) => {
      if (isExpand) {
        setExpandedRowProject(row.id)
      } else {
        setExpandedRowProject(null)
      }
    },
    expanded: [expandedRowProject],
  }

  const handleSubmit = e => {
    e.preventDefault()
    setExpandedRow(null)
    sethideDateColumn(
      moment(startDate).format("YYYY/MM/DD") ===
        moment(endDate).format("YYYY/MM/DD")
        ? true
        : false
    )

    onHandleFilterBtnClicked()
  }

  const handleSubmitteam = e => {
    e.preventDefault()
    setExpandedRowProject(null)
    sethideDateColumn(
      moment(startDate).format("YYYY/MM/DD") ===
        moment(endDate).format("YYYY/MM/DD")
        ? true
        : false
    )

    onHandleFilterBtnClickedteam()
  }
  const { teamList } = useSelector(state => ({
    teamList: state?.createteam?.createTeamLookupList,
  }))

  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
  }, [teamList])

  const handleApprovel = () => {
    const startDate = moment(selectedEvalaution?.starttime).format("YYYY-MM-DD")
    const aprroveTeam = {
      accountid: rowlistData?.accountId,
      date: startDate,
      starttime: selectedEvalaution?.starttime,
      endtime: selectedEvalaution?.endtime,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")
        ?.data?.id,
    }
    dispatch(getApprovesTeamsReport(aprroveTeam))
    setTimeout(() => {
      dispatch(
        GetOnEvaluationHours({
          accountId: !isEmpty(selectedReportItem)
            ? selectedReportItem?.accountId
            : aprroveTeam?.accountid,
          date: !isEmpty(selectedReportItem)
            ? selectedReportItem?.date
            : aprroveTeam?.date,
        })
      )
    }, 500)
    setApproveModal({ open: false, IsAutoClosed: approveModal?.IsAutoClosed })
    if (approveModal?.IsAutoClosed) setismodal(true)
  }

  const handleApprovelAll = (type) => {
    const startDate = moment(rowlistData?.startTime).format("YYYY-MM-DD")
    const aprroveTeamall = {
      accountid: rowlistData?.accountId,
      date: startDate,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")
        ?.data?.id,
    }
    dispatch(getApprovesTeamsReport(aprroveTeamall))
    setTypeApproveAll(type)
  }
  useEffect(() => {
    if (approaval == 200 && typeApproveAll == 'closeAll') {
      setApproveModalAll(false)
      setEvaluationall(false)
      setismodal(false)
      setTypeApproveAll(null)
    }
    if (rejectation == 200 && typeApproveAll == 'closeRejectAll') {
      setRejectModalAll(false)
      setEvaluationall(false)
      setismodal(false)
      setTypeApproveAll(null)
    }
  }, [approaval, rejectation])

  const handleRejectsAll = (type) => {
    const startDate = moment(rowlistData?.startTime).format("YYYY-MM-DD")
    const rejectTeamall = {
      accountid: rowlistData?.accountId,
      date: startDate,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")
        ?.data?.id,
    }
    dispatch(getRejectsTeamsReport(rejectTeamall))
    setTypeApproveAll(type)
  }
  const handleRejects = () => {
    const startDate = moment(selectedEvalaution?.starttime).format("YYYY-MM-DD")
    const rejectTeam = {
      accountid: rowlistData?.accountId,
      date: startDate,
      starttime: selectedEvalaution?.starttime,
      endtime: selectedEvalaution?.endtime,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")
        ?.data?.id,
    }
    dispatch(getRejectsTeamsReport(rejectTeam))
    setTimeout(() => {
      dispatch(
        GetOnEvaluationHours({
          accountId: !isEmpty(selectedReportItem)
            ? selectedReportItem?.accountId
            : rejectTeam?.accountid,
          date: !isEmpty(selectedReportItem)
            ? selectedReportItem?.date
            : rejectTeam?.date,
        })
      )
    }, 500)
    setRejectModal(false)
    if (rejectModal?.IsAutoClosed) setismodal(true)
  }

  const toggleViewVerifyModal = e => {
    setverifyScreen(!verifyScreen)
    setExpandRowItem({})
  }
  // team base screen log
  const screenteamsToggle = () => {
    if (teamscreenModal) {
      setTeamscreenModal(false)
    } else {
      setTeamscreenModal(true)
    }
  }

  const summaryToggle = () => {
    if (summaryModal) {
      setSummaryModal(false)
    } else {
      setSummaryModal(true)
    }
  }
  const summaryToggleteam = () => {
    if (summaryModalteam) {
      setSummaryModalteam(false)
    } else {
      setSummaryModalteam(true)
    }
  }
  const summaryDatateam = row => {
    setSummarydatateam(row)
    setSummaryModalteam(true)
  }

  const summaryData = row => {
    setSummarydata(row)
    setSummaryModal(true)
  }

  const fullviewteamreport = row => {
    setFullviewreport(row)
    setFullviewModalteam(true)
  }

  const fullviewteamToggle = () => {
    if (FullviewModalteam) {
      setFullviewModalteam(false)
    } else {
      setFullviewModalteam(true)
    }
  }
  const onClickSubmitButton = (lists, type) => {
    setEmailSendType(type)
    setSelectedRowDetails(lists || {})
    setOpenUserModal(!openUserModal)
  }

  const onClickQuickSendToClient = lists => {
    onClickSubmitButton(lists, "quickReport")
  }

  const html2pdfFn = async value => {
    setDownloadLoader(true)
    const nameId = document.getElementById("exportPDFData")
    var opt = {
      margin: 15,
      filename: `${value.project}_${value.date}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    }
    try {
      await html2pdf().set(opt).from(nameId).save()
      setDownloadLoader(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownloadLoader(false);
    }
  }
  return (
    <React.Fragment>
      <RejectModal
        show={evaluationall == true ? rejectModalAll : rejectModal?.open}
        rejectModalAll={rejectModalAll}
        evaluationall={evaluationall}
        onDeleteClick={() => { evaluationall == true ? handleRejectsAll('closeRejectAll') : handleRejects() }}
        onCloseClick={() => {
          if (evaluationall == true) {
            setRejectModalAll(false)
            setEvaluationall(false)
          } else {
            setRejectModal({ open: false, IsAutoClosed: false })
          }
        }}
        confirmationText={
          evaluationall == true ? "Yes, Reject All" : "Yes, Reject"
        }
      />
      <ApproveModal
        show={evaluationall == true ? approveModalAll : approveModal?.open}
        evaluationall={evaluationall}
        onDeleteClick={() => {
          evaluationall == true ? handleApprovelAll("closeAll") : handleApprovel()
        }}
        onCloseClick={() => {
          if (evaluationall == true) {
            setApproveModalAll(false)
            setEvaluationall(false)
          } else {
            setApproveModal({ open: false, IsAutoClosed: false })
          }
        }}
      />
      <VerifyScreenModal
        isOpen={verifyScreen}
        toggle={toggleViewVerifyModal}
        screens={screenResponse}
        onHandleverified={onhandleVerified}
        activeScreenFilter={activeScreenFilter}
        setscreenResponse={setscreenResponse}
        type="verifymyteams"
        expandRowItem={expandRowItem}
      />
      <VerifyTeamModal
        isOpen={ismodal}
        toggle={(e) => toggleViewModal(e)}
        handlecancel={handlecancel}
        rowlistData={rowlistData}
        handleApprove={handleApprove}
        handleReject={handleReject}
        sethandleAccordion={sethandleAccordion}
        handleAccordion={handleAccordion}
        setismodal={setismodal}
        handleApproveAll={handleApproveAll}
        handleRejectAll={handleRejectAll}
        HoursReportPage={false}
      />
      <Modal
        isOpen={selectToggle ? summaryModal : summaryModalteam}
        toggle={selectToggle ? summaryToggle : summaryToggleteam}
        size="lg"
      >
        <ModalHeader toggle={selectToggle ? summaryToggle : summaryToggleteam}>
          {"Activity Summary"}
        </ModalHeader>
        <ModalBody>
          <Activity_summary
            summarydata={summarydatas}
            selectToggle={selectToggle}
            summarydatasteam={summarydatasteam}
            sethandleAccordionsummary={sethandleAccordionsummary}
            handleAccordionsummary={handleAccordionsummary}
          />
        </ModalBody>
      </Modal>
      {/* screen logs project base  */}
      <Modal
        isOpen={teamscreenModal}
        toggle={screenteamsToggle}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={screenteamsToggle} tag="h4">
          {"Team Screens"}
        </ModalHeader>
        <ModalBody>
          <TeamScreen
            teamscreen={teamscreen}
            sethandleAccordionteamscreen={sethandleAccordionteamscreen}
            handleAccordionteamscreen={handleAccordionteamscreen}
          />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={FullviewModalteam}
        toggle={fullviewteamToggle}
        size="lg"
        role="dialog"
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        backdrop="static"
      >
        <ModalHeader toggle={fullviewteamToggle} tag="h4">
          <div className="d-flex justify-content-around mb-2">
            <div className="pt-2">Project Screens</div>
            <button
              style={{ position: "absolute", right: "3rem" }}
              type="button"
              className="btn btn-outline-danger btn-lg ms-2"
              onClick={e => html2pdfFn(fullviewreport)}
            >
              Export PDF
            </button>
          </div>
        </ModalHeader>
        {downloadLoader ? <div id="cover-spin"></div> : null}
        <ModalBody id="exportPDFData">
          <Fullviewproject fullviewreport={fullviewreport} />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={openUserModal}
        toggle={() => setOpenUserModal(!openUserModal)}
        size="lg"
        role="dialog"
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        backdrop="static"
      >
        <ModalHeader
          toggle={() => {
            setOpenUserModal(!openUserModal)
          }}
          tag="h5"
        >
          {!createUserScreen ? "Select the client " : "Add new client"}
          {/* <img  */}
        </ModalHeader>
        <ModalBody>
          {!createUserScreen && (
            <ClientList
              clientsEmail={clientsEmail}
              HandleSubmitClick={HandleSubmitClick}
              setCreateUserScreen={setCreateUserScreen}
              categoryId={selectedRowDetails[0]?.clientId}
              subcategoryId={selectedRowDetails[0]?.projectId}
            />
          )}
          {createUserScreen && (
            <UserForm
              handleUserCancel={() => setCreateUserScreen(false)}
              toggle={() => setCreateUserScreen(!createUserScreen)}
              categoryId={selectedRowDetails[0]?.clientId}
            />
          )}
        </ModalBody>
      </Modal>

      {/* end screen team screen logs */}
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Verify Team Hours"}
            breadcrumbItem={"Verify Team Hours"}
          />
          <Card>
            <CardBody>
              <FilterLayout
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                sethideDateColumn={sethideDateColumn}
                endDate={endDate}
                teamsReportList={reports || []}
                selectedHours={selectedHours}
                hoursList={hoursList}
                activeReportStatus={activeReportStatus}
                handleProjectFilter={handleProjectFilter}
                handleClientFilter={handleClientFilter}
                handleReportFilter={handleReportFilter}
                handleHoursFilter={handleHoursFilter}
                MainCategory={teamList?.categoryLookup}
                SubCategory={filtersubCategory}
                companySetting={companySetting}
                handleSubmit={handleSubmit}
                teams={teamList?.subCategoryLookup}
                handleNameDropdownFilter={handleNameFilter}
                toggleChecked={toggleChecked}
                selectToggle={selectToggle}
                handleSubmitteam={handleSubmitteam}
                handleHoursFilterteam={handleHoursFilterteam}
                selectedHoursteam={selectedHoursteam}
                hoursListteam={hoursListteam}
                setSelecteduserd={setSelecteduserd}
                setSelectedclientId={setSelectedclientId}
                setSelectedprojectId={setSelectedprojectId}
                modeCompact={modeCompact}
                setModeCompact={setModeCompact}
                handleCompactFilter={handleCompactFilter}
                handlebillableFilter={handlebillableFilter}
                getallbillingtypes={getallbillingtypes}
                billableType={billableType}
                loadTeamScreenteam={loadTeamScreenteam}
              />

              <Row>
                <Col xs="12">
                  <div
                    className={`${!isMobile
                      ? "p-0 table-responsive-align my-teams-align-table"
                      : "rwd-table"
                      }`}
                  >
                    <>
                      {!isMobile ? (
                        <BootstrapTable
                          // key={JSON.stringify(teamsReportListteam)}
                          keyField="id"
                          data={
                            !selectToggle
                              ? (teamsReportListteam || [])
                                //?.sort(customSort)
                                ?.filter(el => !isEmpty(el?.timeSheetReports))
                              : (teamsReportList || []).filter(
                                el => !isEmpty(el?.projectTimeSheet)
                              )
                          }
                          columns={
                            !selectToggle
                              ? TeamtimeSheetHeaderColumns
                              : timeSheetHeaderColumns
                          }
                          expandRow={
                            !selectToggle ? expandRowProject : expandRow
                          }
                          headerClasses="table-light table-bordered  rwd-table"
                          defaultSortDirection="asc"
                          noDataIndication="Sorry, There are no data to display"
                        />
                      ) : (
                        <MyContext.Provider
                          value={{
                            dataTeam: !selectToggle
                              ? (teamsReportListteam || []).filter(
                                el => !isEmpty(el?.timeSheetReports)
                              )
                              : (teamsReportList || []).filter(
                                el => !isEmpty(el?.projectTimeSheet)
                              ),
                            selectToggleTeam: selectToggle,
                            classnames: classnames,
                            Reporticon: Reporticon,
                            Imageicon: Imageicon,
                            summaryDatateam: summaryDatateam,
                            handleverifyScreenproject:
                              handleverifyScreenproject,
                            fullviewteamreport: fullviewteamreport,
                            renderWorkStatus: renderWorkStatus,
                            projectreport: projectreport,
                            toggleViewModal: toggleViewModal,
                            setSelectedReportItem: setSelectedReportItem,
                            handleverifyScreen: handleverifyScreen,
                            // button below report status
                            getUnVerifiedErrorLists: getUnVerifiedErrorLists,
                            getErrorListsUnSubmitted: getErrorListsUnSubmitted,
                            getOnEvaluationErrorList: getOnEvaluationErrorList,
                            accessgroupname: accessgroupname,
                            onClickSubmitButton: onClickSubmitButton,
                            ExcludeNonReportFunction: ExcludeNonReportFunction,
                            selectedArrayLists: selectedArrayLists,
                            setSelectedArrayLists: setSelectedArrayLists,
                            noRowsSelected: noRowsSelected,
                            summaryData: summaryData,
                            handleverifyScreenrow: handleverifyScreenrow,
                            // handleverifyScreenrow: !selectToggle
                            // ? handleverifyScreenproject
                            // : handleverifyScreenrow,
                            isMobileTeam: isMobile,
                            onClickQuickSendToClient: onClickQuickSendToClient,
                            compactView: compactView,
                            teamsReportListteam: teamsReportListteam
                          }}
                        >
                          <MobileTable />
                        </MyContext.Provider>
                      )}
                    </>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

VerifyScreenTeams.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VerifyScreenTeams
export { MyContext }
